export default __webpack_public_path__ + "static/mainImg-aff2c1d5a0a5d9b1f95b3ba8a2770af7.png";